import { parseQuery } from "../containers/PdfPublication/utils"

export const checkIsPreviewMode = (location) => {
  const queryParams = parseQuery(location?.search || '')
  return queryParams.preview === 'true'
}
